export default __webpack_public_path__ + "static/media/APPLICATION.7ff20887.svg";